<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="card mx-2">
          <div class="card-body">
            <label class="fs-5 mt-3 mb-4">{{ roleId == 0 ? "Create" : "Update" }} Role</label>
            <b-row class="py-2" v-if="role.name != 'Super Admin'">
              <b-col>
                <div class="d-inline me-2">
                  <label>Status</label>
                </div>
                <div class="form-check form-switch form-switch-md d-inline">
                  <input
                    :disabled="role.name == 'Super Admin'"
                    v-model="role.isActive"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    class="form-check-input float-none"
                    block
                    v-b-toggle.accordion-2
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="py-3">
              <b-col cols="5">
                <label for=""
                  >Role Name <span style="color: red">*</span></label
                >
                <input
                  v-model="role.name"
                  :disabled="role.name == 'Super Admin'"
                  type="text"
                  id="default-input"
                  placeholder="Enter Role Name"
                  class="form-control"
                  trim
                  :class="{
                    'is-invalid': submitted && $v.role.name.$error,
                  }"
                />
                <div
                  v-if="submitted && !$v.role.name.required"
                  class="invalid-feedback"
                >
                  Role Name is required.
                </div>
              </b-col>
              <b-col cols="7">
                <label for="">Role Description</label>
                <input
                  v-model="role.description"
                  type="text"
                  id="default-input"
                  placeholder="Enter Role Description"
                  class="form-control"
                  trim
                />
              </b-col>
            </b-row>
            <b-row class="py-3">
              <label class="fw-medium" for="">Permission</label>
              <b-col cols="12">
                <div
                  v-for="(item, index) in role.access"
                  :key="index"
                  class="accordion mb-3"
                  role="tablist"
                >
                  <b-card no-body class="mb-1">
                    <b-card-header
                      header-tag="header"
                      class="px-4 py-2"
                      role="tab"
                    >
                      <b-row>
                        <b-col>
                          <label class="mt-1">{{ item.label }}</label>
                        </b-col>
                        <b-col class="text-end">
                          <div class="d-inline me-2">
                            <label>Status</label>
                          </div>
                          <div
                            class="form-check form-switch form-switch-md d-inline"
                          >
                            <input
                              type="checkbox"
                              id="flexSwitchCheckChecked"
                              :checked="item.enabled"
                              v-model="item.enabled"
                              class="form-check-input float-none"
                              block
                              v-b-toggle="`accordion-${index}`"
                              @change="
                                onParentCategoryToggle(
                                  item.modules,
                                  item.enabled
                                )
                              "
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </b-card-header>
                    <b-collapse
                      :id="`accordion-${index}`"
                      :visible="item.enabled"
                      :accordion="`my-accordion-${index}`"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-table
                          borderless
                          fixed
                          responsive
                          :fields="fields"
                          :items="item.modules"
                        >
                          <template #cell(name)="row">
                            <span class="text-body fw-medium m-0">{{
                              row.item.label
                            }}</span>
                          </template>

                          <template #cell(create)="row">
                            <div
                              class="form-check form-switch form-switch-md d-inline"
                              v-if="row.item.access.hasOwnProperty('create')"
                            >
                              <input
                                type="checkbox"
                                id="flexSwitchCheckChecked"
                                class="form-check-input float-none custom-switch-size"
                                v-model="row.item.access.create"
                                @change="onAccessToggle(row.item)"
                                :disabled="true"
                              />
                            </div>
                          </template>

                          <template #cell(read)="row">
                            <div
                              class="form-check form-switch form-switch-md d-inline"
                              v-if="row.item.access.hasOwnProperty('read')"
                            >
                              <input
                                type="checkbox"
                                id="flexSwitchCheckChecked"
                                class="form-check-input float-none custom-switch-size"
                                v-model="row.item.access.read"
                                @change="onAccessToggle(row.item)"
                                :disabled="true"
                              />
                            </div>
                          </template>

                          <template #cell(update)="row">
                            <div
                              class="form-check form-switch form-switch-md d-inline"
                              v-if="row.item.access.hasOwnProperty('update')"
                            >
                              <input
                                type="checkbox"
                                id="flexSwitchCheckChecked"
                                class="form-check-input float-none custom-switch-size"
                                v-model="row.item.access.update"
                                @change="onAccessToggle(row.item)"
                                :disabled="true"
                              />
                            </div>
                          </template>

                          <template #cell(delete)="row">
                            <div
                              class="form-check form-switch form-switch-md d-inline"
                              v-if="row.item.access.hasOwnProperty('delete')"
                            >
                              <input
                                type="checkbox"
                                id="flexSwitchCheckChecked"
                                class="form-check-input float-none custom-switch-size"
                                v-model="row.item.access.delete"
                                @change="onAccessToggle(row.item)"
                                :disabled="true"
                              />
                            </div>
                          </template>

                        </b-table>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-col>
            </b-row>

            <div class="text-end mt-3 mb-3">
              <button
                type="button"
                class="btn w-sm btn-light"
                @click="$router.back()"
              >
                Cancel
              </button>
              <button
                :disabled="isLoading"
                type="button"
                class="btn w-sm ms-2 btn-primary"
                @click="roleId == 0 ? createRole() : updateRole()"
              >
                <span
                  v-if="isLoading"
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ roleId == 0 ? "Create" : "Update" }}
              </button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import { modules } from "./modules";
import { required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import { rolesMethods, rolesComputed, layoutMethods, layoutComputed } from "@/state/helpers";
import { getModuleAccess } from '@/helpers/helper.js'
// import Swal from "sweetalert2";

export default {
  page: {
    title: "Role",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      isLoading: false,
      checked: true,
      roleId: 0,
      role: {
        orgId: "",
        name: "",
        description: "",
        isActive: true,
        access: [],
      },
      fields: [
        {
          key: "name",
          label: "Module",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "create",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "read",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "update",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "delete",
          sortable: false,
          tdClass: "align-middle",
        },
      ],
      submitted: false,
      toastTitle: "",
      toastMessage: "",
      toastType: "",
      showToast: false,
      access: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      moduleList: []
    };
  },
  validations: {
    role: {
      name: { required },
    },
  },
  computed: {
    ...rolesComputed,
    ...layoutComputed
  },
  created() {},
  methods: {
    ...rolesMethods,
    ...layoutMethods,
    enforceReadOnlyAccess(modules) {
      if (!modules || !modules.length) return;
      for (let module of modules) {
        if (!module.access || typeof module.access !== 'object') {
          module.access = { create: false, read: true, update: false, delete: false };
        } else {
          module.access.create = false;
          module.access.update = false;
          module.access.delete = false;
          module.access.read = true;
        }

        if (module.submodules && module.submodules.length) {
          for (let sub of module.submodules) {
            if (!sub.access || typeof sub.access !== 'object') {
              sub.access = { create: false, read: true, update: false, delete: false };
            } else {
              sub.access.create = false;
              sub.access.update = false;
              sub.access.delete = false;
              sub.access.read = true;
            }
            sub.enabled = !!sub.access.read;
          }
        }

        module.enabled = !!module.access.read;
      }
    },

    onParentCategoryToggle(modules, enabled) {
      // Allow Super Admin to retain full access toggling behavior
      if (this.role && this.role.name === 'Super Admin') {
        for (let module of modules) {
          module.enabled = enabled;
          if (module.access && Object.keys(module.access).length) {
            for (let prop in module.access) {
              module.access[prop] = enabled;
            }
          }

          if (module.submodules && module.submodules.length) {
            for (let sub of module.submodules) {
              sub.enabled = enabled;
              if (sub.access && Object.keys(sub.access).length) {
                for (let prop in sub.access) {
                  sub.access[prop] = enabled;
                }
              }
            }
          }
        }
        return;
      }

      // For non-Super Admin roles, only toggle 'read' and force others false
      for (let module of modules) {
        module.enabled = enabled;
        if (module.access && typeof module.access === 'object') {
          module.access.read = enabled;
          module.access.create = false;
          module.access.update = false;
          module.access.delete = false;
        } else {
          module.access = { create: false, read: enabled, update: false, delete: false };
        }

        if (module.submodules && module.submodules.length) {
          for (let sub of module.submodules) {
            sub.enabled = enabled;
            if (sub.access && typeof sub.access === 'object') {
              sub.access.read = enabled;
              sub.access.create = false;
              sub.access.update = false;
              sub.access.delete = false;
            } else {
              sub.access = { create: false, read: enabled, update: false, delete: false };
            }
          }
        }
      }
    },

    onAccessToggle(module) {
      // Super Admin uses original toggle behavior
      if (this.role && this.role.name === 'Super Admin') {
        for (let prop in module.access) {
          if (module.access[prop] == true) {
            module.enabled = true;
            break;
          } else {
            module.enabled = false;
          }
        }
        return;
      }

      // For other roles: only 'read' influences enabled, force others false
      module.access.create = false;
      module.access.update = false;
      module.access.delete = false;
      module.enabled = !!module.access.read;
    },
    async createRole() {
      if (!this.access.create) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }

      this.submitted = true;
      this.$v.$touch();

      if (this.$v.role.name.$invalid) {
        return; // prevent proceeding to creation if role name is empty
      }

      const params = {
        name: this.role.name,
        description: this.role.description,
        access: JSON.stringify(this.role.access),
        isActive: this.role.isActive ? 1 : 0,
        createdBy: JSON.parse(localStorage.getItem("userData")).email,
      };
      this.isLoading = true;
      this.createRoleItem(params)
        .then(async (res) => {
          this.isLoading = false;
          let toastValues = {
            type: res.status == 'ok' ? "success" : "danger",
            title: res.status == 'ok' ? "Success" : "Failed",
            message: res.status == 'ok' ? "You successfully created a role." : "Unexpected error occurs. Please try again.",
          }
          this.$emit('show-toast', toastValues)
          if (res.status == 'ok') this.$router.back();
        })
        .catch(async (err) => {
          this.isLoading = false;
          console.log(err);
          this.$toast.showToast('danger', 'Failed', 'Unexpected error occurs. Please try again.');
        });
    },
    async updateRole() {
      if (!this.access.update) {
        this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
        return
      }

      this.submitted = true;
      this.$v.$touch();

      if (this.$v.role.name.$invalid) {
        return; // prevent proceeding to creation if role name is empty
      }
      let params = {
        id: this.roleId,
        name: this.role.name,
        description: this.role.description,
        access: JSON.stringify(this.role.access),
        isActive: this.role.isActive ? 1 : 0,
        updatedBy: JSON.parse(localStorage.getItem("userData")).email,
      };
      
      this.isLoading = true;
      this.updateRoleItem(params)
        .then(() => {
          this.isLoading = false;
          let toastValues = {
            type: "success",
            title: "Success",
            message: "You successfully updated a role.",
          }
          this.$emit('show-toast', toastValues)
          this.$router.back();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          this.$toast.showToast('danger', 'Failed', 'Unexpected error occurs. Please try again.');
        });
    },
    async getRoleById() {
      let params = {
        id: this.$route.params.id,
      };

      this.getRole(params)
        .then(() => {
          this.role = {
            orgId: this.roleItem.orgId,
            name: this.roleItem.name,
            description: this.roleItem.description,
            isActive: this.roleItem.isActive,
            access: JSON.parse(this.roleItem.access),
          };

          let categoryIndex = this.role.access.findIndex(item => item.name == 'Find Space');
          let browseSpaceIndex = this.role.access[categoryIndex].modules.findIndex(item => item.name == 'Browse Available');
          this.role.access[categoryIndex].modules.splice(browseSpaceIndex, 1);

          console.log(this.role.access)

          for (let roleItem of this.role.access) {
            for (let item of this.moduleList) {
              if (roleItem.name == item.name) {
                for (let module of item.modules) {

                  if (!roleItem.modules.some((i) => i.name == module.name)) {
                    // push a deep clone to avoid mutating shared references
                    const cloned = JSON.parse(JSON.stringify(module));
                    // if Super Admin, ensure missing modules have full access
                    if (this.role && this.role.name === 'Super Admin') {
                      if (!cloned.access || typeof cloned.access !== 'object') cloned.access = {};
                      cloned.access.create = true;
                      cloned.access.read = true;
                      cloned.access.update = true;
                      cloned.access.delete = true;
                      cloned.enabled = true;
                      if (cloned.submodules && cloned.submodules.length) {
                        for (let sub of cloned.submodules) {
                          if (!sub.access || typeof sub.access !== 'object') sub.access = {};
                          sub.access.create = true;
                          sub.access.read = true;
                          sub.access.update = true;
                          sub.access.delete = true;
                          sub.enabled = true;
                        }
                      }
                    }
                    roleItem.modules.push(cloned);
                  }

                  // add checking of submodules
                }
              }
            }
            // enforce read-only access on merged modules only for non Super Admin roles
            if (this.role.name !== 'Super Admin') {
              this.enforceReadOnlyAccess(roleItem.modules);
            }
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    },
    showRowDetails(row) {
      row.toggleDetails();
    },
  },
  async mounted() {
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "User Management" },
        { text: "Roles", to: { name: "roles-management" } },
        { text: `${this.$route.params.id == undefined ? 'Add' : 'Edit'}`},
      ],
    });
    this.changeBackButton({
      value: true
    });
    this.changePrevRoute({
        name: 'roles',
        params: {}
    })

    await this.getModules()
      .then(() => {
        this.moduleList = JSON.parse(this.modules);
      })

    if (this.$route.params.id != undefined) {
      this.roleId = this.$route.params.id;
      this.getRoleById();
    } else {
      this.role.access = JSON.parse(JSON.stringify(this.moduleList));
      for (let roleItem of this.role.access) {
        if (this.role.name !== 'Super Admin') {
          this.enforceReadOnlyAccess(roleItem.modules);
        }
      }
    }

    await this.getModules()
      .then(() => {
        this.moduleList = JSON.parse(this.modules);
        console.log('moduleList: ', this.moduleList)
      })

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess("User Management", "Roles")
      .then((access) => {
        this.access = access
      }
    );
  },
};
</script>

<style>
.table {
  --bs-table-bg: transparent;
}

.custom-switch-size {
  font-size: 19px;
}

.swal2-bottom-end {
  margin-bottom: 4rem;
  width: fit-content !important;
  overflow-y: auto;
  margin-right: 6px !important;
}

.colored-toast.swal2-icon-success {
  background-color: #508f30 !important;
}

.colored-toast .swal2-title {
  color: white;
}

.colored-toast .swal2-close {
  color: white;
}

.colored-toast .swal2-html-container {
  color: white;
}

.colored-toast .swal2-text {
  color: white;
}

.table td {
  width: 300px;
}

.td-no-padding {
  padding: 0;
}

.b-table-details td {
  padding: 0;
}

#sub-table td {
  padding: 0.75rem 0.75rem !important;
}

.hidden_header {
  display: none;
}

.form-check-input {
  border-color: #7e93a059;
}
</style>
